export const INTERNAL_NETWORK_SETTINGS_TABS = {
  GENERAL: 'general',
  NETWORK: 'network',
  SENSOR: 'sensor',
  EXECUTION: 'execution',
  CREDENTIALS: 'credentials',
  DANGER: 'danger',
} as const;

export type InternalNetworkSettingsTabId =
  (typeof INTERNAL_NETWORK_SETTINGS_TABS)[keyof typeof INTERNAL_NETWORK_SETTINGS_TABS];

export type InternalNetworkSettingsTabLabelKey =
  | InternalNetworkSettingsTabId
  | 'connection';

export type InternalNetworkSettingsNavItem = {
  value: InternalNetworkSettingsTabId;
  labelKey: InternalNetworkSettingsTabLabelKey;
};

export type InternalNetworkSettingsTabAccess = {
  isTunnelModeEnabled: boolean;
  canManageInternalNetwork: boolean;
};

export const getInternalNetworkSettingsNavItems = ({
  isTunnelModeEnabled,
  canManageInternalNetwork,
}: InternalNetworkSettingsTabAccess): InternalNetworkSettingsNavItem[] => [
  { value: INTERNAL_NETWORK_SETTINGS_TABS.GENERAL, labelKey: 'general' },
  { value: INTERNAL_NETWORK_SETTINGS_TABS.NETWORK, labelKey: 'network' },
  {
    value: INTERNAL_NETWORK_SETTINGS_TABS.SENSOR,
    labelKey: isTunnelModeEnabled ? 'connection' : 'sensor',
  },
  { value: INTERNAL_NETWORK_SETTINGS_TABS.EXECUTION, labelKey: 'execution' },
  {
    value: INTERNAL_NETWORK_SETTINGS_TABS.CREDENTIALS,
    labelKey: 'credentials',
  },
  ...(canManageInternalNetwork
    ? [
        {
          value: INTERNAL_NETWORK_SETTINGS_TABS.DANGER,
          labelKey: 'danger' as const,
        },
      ]
    : []),
];

export const resolveInternalNetworkSettingsActiveTab = ({
  activeTab,
  navItems,
}: {
  activeTab: string;
  navItems: readonly InternalNetworkSettingsNavItem[];
}): InternalNetworkSettingsTabId =>
  navItems.find((item) => item.value === activeTab)?.value ??
  INTERNAL_NETWORK_SETTINGS_TABS.GENERAL;
